module.exports = __webpack_public_path__ + "static/media/man-superhero_1f9b8-200d-2642-fe0f.7537b88f.png";